import Vue from "vue";
import VueCollapse from 'vue2-collapse';
import Vuex from 'vuex'
import configuratorStore from './stores/configuratorStore.js';
import vSelect from 'vue-select'
import ProductConfigurator from './components/ProductConfigurator.vue';
import ProductBenefits from './components/ProductBenefits.vue';
import ProductOverview from './components/ProductOverview.vue';
import QualityDetails from './components/QualityDetails.vue';
import RelatedProducts from './components/RelatedProducts.vue';
import RelatedProduct from './components/RelatedProduct.vue';
import FaqAccordion from './components/FaqAccordion.vue';
import FeatureMatrixTable from './components/FeatureMatrixTable.vue';

Vue.component('product-configurator', ProductConfigurator);
Vue.component('product-benefits', ProductBenefits);
Vue.component('product-overview', ProductOverview);
Vue.component('quality-details', QualityDetails);
Vue.component('related-products', RelatedProducts);
Vue.component('related-product', RelatedProduct);
Vue.component('faq-accordion', FaqAccordion);
Vue.component('feature-matrix-table' , FeatureMatrixTable);
Vue.component('v-select', vSelect)

Vue.use(VueCollapse);
Vue.use(Vuex);

if(document.getElementById("landingApp")) {
    new Vue({
        el: '#landingApp',
        store: configuratorStore,
        methods: {
            'qualityChanged': function (qualityId) {
                for (let it of document.getElementsByClassName("quality-text")) {
                    it.classList.add('hidden');
                }

                let currentQualityText = document.getElementById("quality-text-" + qualityId);
                if (currentQualityText) {
                    currentQualityText.classList.remove('hidden');
                }
            }
        }
    });
}

let normalNavigation = document.querySelector('.navigation-wrapper');
let minimalNavigation = document.querySelector('.navigation-min');

function changeConfiStyleFn () {
    let headerPosition, footerPosition;
    headerPosition = footerPosition = '';

    let productConfigurator = document.getElementsByClassName('hep-config')[0];
    if (!productConfigurator) {
        return;
    }

    let footerSection = document.querySelector('.landing-footer');
    if (footerSection) footerPosition = footerSection.getBoundingClientRect();

    if (normalNavigation) headerPosition = normalNavigation.getBoundingClientRect();
    if (minimalNavigation) headerPosition = minimalNavigation.getBoundingClientRect();

    let footerVisible = (window.innerHeight - footerPosition.top);
    let footerSpace = ((footerVisible + productConfigurator.offsetHeight) + 30);

    if (productConfigurator.offsetHeight <= window.innerHeight) {
        if ((footerVisible >= 0) && (footerSpace >= window.innerHeight)) {
            productConfigurator.style.bottom = (window.innerHeight - footerPosition.top + 27) + 'px';
            productConfigurator.style.top = '';
        } else {
            productConfigurator.style.bottom = '';
            productConfigurator.style.top = headerPosition.bottom >= 0 ? (headerPosition.bottom) + 'px' : '0px';
        }
    } else {
        productConfigurator.style.position = 'static';
    }
}

let scrWidth = document.documentElement.clientWidth;

if (scrWidth > 991) {
    window.addEventListener('scroll', changeConfiStyleFn);
}
